import { REDUCER_NAME } from './const'

const NS = REDUCER_NAME + '/'

export const INIT_GLOBALS = NS + 'INIT_GLOBALS'

export const SAVE_VIEW_PREFERENCES = NS + 'SAVE_VIEW_PREFERENCES'


// WEBPACK FOOTER //
// ./src/modules/globals/state/type.js